/**
 * Bootstrap device credentials desde localStorage (A7 RESEARCH).
 * Para demo 11-15 mayo: poblar manualmente vía dev tools antes del demo:
 *   localStorage.setItem('device_id', 'tab-pdvSC-01')
 *   localStorage.setItem('device_token', '<hmac-token>')
 *
 * Phase 5 piloto: UI de pairing self-service (deferida en CONTEXT).
 *
 * T-04-01-09: el device_token se distribuye out-of-band; riesgo: dev olvida
 * limpiar el token de tablet de prueba. Mitigación: documentación.
 */
import type { DeviceCreds } from '../api/client'

export function useDeviceCreds(): DeviceCreds | null {
  const device_id = localStorage.getItem('device_id')
  const device_token = localStorage.getItem('device_token')
  if (!device_id || !device_token) return null
  return { device_id, device_token }
}
